import { useLog } from "@/composables/log";
import { MaybeRefOrGetter, toValue } from "vue";

export function useScroll(element: MaybeRefOrGetter<HTMLElement>) {
    const log = useLog();

    const elementValue = toValue(element);

    const toTop = () => {
        log.debug("Scrolling to element top...", {
            element: elementValue,
        });

        elementValue.classList.add("scroll-mt-20");
        elementValue.scrollIntoView({
            behavior: "smooth",
        });
        elementValue.classList.remove("scroll-mt-20");
    };

    return {
        toTop,
    };
}
